// modules/StoreLocator/api.ts
import type { Store } from '../types';

/**
 * Retrieves blinds from the WP API
 */
export async function fetchStores(params: Record<string, any>): Promise<Store[]> {
    const apiUrlGetStores = window.StoreLocatorSettings?.apiUrlGetStores;
    if (!apiUrlGetStores) throw new Error('StoreLocatorSettings.apiUrlGetStores non défini');

    const url = new URL(apiUrlGetStores, window.location.origin);
    for (const [key, value] of Object.entries(params)) {
        if (value === undefined || value === null) continue;

        if (Array.isArray(value)) {
            if (value.length === 0) continue;
            url.searchParams.set(key, value.join(','));
            continue;
        }

        const stringValue = String(value).trim();
        if (stringValue.length === 0) continue;
        url.searchParams.set(key, stringValue);
    }


    const res = await fetch(url.toString(), { credentials: 'same-origin' });
    if (!res.ok) {
        const t = await res.text();
        throw new Error(`Erreur API (${res.status}): ${t}`);
    }
    const data = await res.json();
    return data as Store[];
}
